export default function play(elements, animationClass) {
  if (!elements || !elements.length || elements.length <= 0) return;

  // 创建监听
  const intersectionObserver = new IntersectionObserver(entries => {
    for (let entry of entries) {
      if (entry.intersectionRatio > 0) {
        addAnimationClass(entry.target, animationClass);
      } else {
        // console.log(animationClass)
        removeAnimationClass(entry.target, animationClass);
      }
    }
  });
  // 添加动画class的操作
  function addAnimationClass(elem, animationClass) {
    elem.className.includes(animationClass)
      ? 1
      : (elem.className = elem.className + " " + animationClass);
  }
  // 移除动画class的操作
  function removeAnimationClass(elem, animationClass) {
    elem.className.includes(animationClass)
      ? (elem.className = elem.className.replace(animationClass, ""))
      : 1;
    // console.log(elem.className)
  }

  for (let i = 0; i < elements.length; i++) {
    const b = elements[i];
    if (b) {
      // 开启监听
      intersectionObserver.observe(b);
    }
  }
}
